module.exports = __webpack_public_path__ + "static/img/Front Eureka_7.22c15d22.png";